module.exports = __webpack_public_path__ + "df3b5a3240cd81bdd2654fd7640f908d.jpg";